import React, { useState } from "react";
import { Input, Search } from "lift-ui";
import { useAuthContext } from "@lift-admin/utils/provider";
import BrandTable from "./components/brand-table/brand-table.component";

const BrandParamsMO = () => {
  const { canEdit, canManage } = useAuthContext();
  const hasEditAccess = canEdit("brand_mgmt");
  const hasManageAccess = canManage("brand_mgmt");

  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Page Header - same layout as Users page */}
      <div className="flex items-center justify-between px-8 py-4 border-b bg-white gap-4">
        <h1 className="text-xl font-semibold text-gray-900">Brand Info MO</h1>
        <div className="flex items-center gap-3 flex-1 justify-end">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search brands..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 w-80"
            />
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col min-h-0 px-8 py-6">
        <BrandTable searchQuery={searchQuery} hasEditAccess={hasEditAccess} hasManageAccess={hasManageAccess} />
      </div>
    </div>
  );
};

export default BrandParamsMO;
